import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { LazyLoadImageModule } from "ng-lazyload-image";
import { ScrollToModule } from "ng2-scroll-to-el";
import { NgStickyDirective } from "ng-sticky";

import { NgStickyModule } from "ng-sticky";
import { ToastrModule } from "ngx-toastr";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AppComponent } from "./app.component";
import { HeaderComponent } from "./components/header/header.component";
import { FooterComponent } from "./components/footer/footer.component";
import { ContentComponent } from "./components/content/content.component";
import { HamburgerComponent } from "./components/hamburger/hamburger.component";
import { LazyImageComponent } from "./components/lazy-image/lazy-image.component";

import { MenuService } from "./services/menu.service";
import { ModalService } from "./services/modal.service";

import { ContactComponent } from "./components/contact/contact.component";
import { ReferralComponent } from "./components/referral/referral.component";
import { ModalComponent } from "./directives/modal/modal.component";

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    ContentComponent,
    HamburgerComponent,
    LazyImageComponent,
    ContactComponent,
    ReferralComponent,
    ModalComponent,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    HttpClientModule,
    LazyLoadImageModule,
    NgStickyModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    ScrollToModule.forRoot(),
  ],
  providers: [MenuService, ModalService],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// /Users/nicholasmurray/Documents/firebase-websites/CommunityAdviceNMD/src/app/app.module.ts